<template>
  <div style="height: 610px; display: flex; flex-direction: column">
    <v-card
      class="outlined-card"
      elevation="0"
      style="flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden"
    >
      <!-- Header -->
      <div class="activity-header px-5 pt-5 pb-3">
        <div class="text-subtitle-1 font-weight-bold text-uppercase" style="color: #212121; letter-spacing: 0.05em">
          Hoạt động hôm nay
        </div>
      </div>

      <div v-if="loading" class="d-flex justify-center align-center py-6">
        <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
      </div>

      <div v-else-if="!activities.length" class="d-flex justify-center align-center py-6 grey--text text-body-2">
        Chưa có hoạt động nào
      </div>

      <div v-else class="activity-list px-4 pb-4" @scroll="onScroll" style="overflow-y: auto; flex: 1; min-height: 0">
        <div v-for="(item, index) in activities" :key="index" class="activity-item py-2">
          <div class="d-flex align-start">
            <div :class="getBadgeClass(item.type)" class="activity-badge mr-3 flex-shrink-0">
              {{ getBadgeLabel(item.type) }}
            </div>
            <div class="flex-grow-1">
              <div class="activity-name font-weight-bold text-body-2">{{ item.title || 'Thông báo hệ thống' }}</div>
              <div class="activity-time text-caption grey--text mb-0">{{ item.createdAt | formatTime }}</div>
              <div class="activity-desc text-body-2" style="color: #555">{{ item.content || '' }}</div>
            </div>
          </div>
        </div>
        <div v-if="loadingMore" class="d-flex justify-center py-2">
          <v-progress-circular indeterminate color="primary" size="20"></v-progress-circular>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { PostStaff } from '@/plugins/api'

export default {
  name: 'DashboardActivities',
  data: () => ({
    loading: true,
    loadingMore: false,
    activities: [],
    totalCount: 0,
    scrollTimeout: null,
  }),
  filters: {
    formatTime(val) {
      if (!val) return ''
      return moment(val).format('HH:mm, DD/MM')
    },
  },
  created() {
    this.fetchActivities()
  },
  methods: {
    async fetchActivities() {
      this.loading = true
      try {
        const params = { _limit: 8, _sort: 'createdAt:DESC', receiver: this.$auth.user.id }
        const [activitiesRes, countRes] = await Promise.all([PostStaff.fetch(params), PostStaff.count(params)])

        const fetchedActivities = Array.isArray(activitiesRes)
          ? activitiesRes
          : activitiesRes && activitiesRes.data
          ? activitiesRes.data
          : []
        const fetchedCount =
          typeof countRes === 'number'
            ? countRes
            : countRes && countRes.count
            ? countRes.count
            : countRes && countRes.data
            ? countRes.data
            : 0

        this.activities = fetchedActivities
        this.totalCount = fetchedCount
      } catch (err) {
        console.error('Failed to fetch activities:', err)
      } finally {
        this.loading = false
      }
    },
    async loadMore() {
      if (this.loadingMore || this.activities.length >= this.totalCount) return
      this.loadingMore = true
      try {
        const params = {
          _limit: 8,
          _sort: 'createdAt:DESC',
          _start: this.activities.length,
          receiver: this.$auth.user.id,
        }
        const newActivitiesRes = await PostStaff.fetch(params)
        const newActivities = Array.isArray(newActivitiesRes)
          ? newActivitiesRes
          : newActivitiesRes && newActivitiesRes.data
          ? newActivitiesRes.data
          : []
        this.activities = [...this.activities, ...newActivities]
      } catch (err) {
        console.error('Failed to load more activities:', err)
      } finally {
        this.loadingMore = false
      }
    },
    onScroll(e) {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout)
      }
      this.scrollTimeout = setTimeout(() => {
        const { scrollTop, clientHeight, scrollHeight } = e.target
        if (scrollTop + clientHeight >= scrollHeight - 20) {
          this.loadMore()
        }
      }, 200) // Throttle 200ms
    },
    getBadgeClass(type) {
      switch (type) {
        case 'notification':
          return 'badge-xt'
        case 'teacher-doc':
          return 'badge-gv'
        case 'salary':
          return 'badge-hs'
        default:
          return 'badge-default'
      }
    },
    getBadgeLabel(type) {
      switch (type) {
        case 'notification':
          return 'TB'
        case 'teacher-doc':
          return 'GV'
        case 'salary':
          return 'LG'
        default:
          return 'SK'
      }
    },
  },
}
</script>

<style scoped>
.outlined-card {
  border: 1px solid #dde3f0 !important;
  border-radius: 16px !important;
  box-shadow: 0 2px 12px rgba(25, 50, 120, 0.08) !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.activity-header {
  border-bottom: 1px solid #f0f2f8;
  flex-shrink: 0;
}

.activity-list {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.activity-item {
  border-bottom: 1px solid #f5f6fa;
}

.activity-item:last-child {
  border-bottom: none;
}

/* Badge base */
.activity-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

/* Badge theo loại */
.badge-xt {
  background-color: #e3f0ff;
  color: #1565c0;
}
.badge-hs {
  background-color: #ede7f6;
  color: #6a1b9a;
}
.badge-gv {
  background-color: #fff3e0;
  color: #e65100;
}
.badge-default {
  background-color: #e8edf7;
  color: #3a5bb8;
}

.activity-name {
  color: #1a237e;
  line-height: 1.4;
}

.activity-time {
  font-size: 11px;
  line-height: 1.3;
}

.activity-desc {
  line-height: 1.5;
  font-size: 13px;
}

.activity-list::-webkit-scrollbar {
  width: 6px;
}
.activity-list::-webkit-scrollbar-thumb {
  background-color: #c9d3ea;
  border-radius: 3px;
}
</style>
